import { Component, Host, Prop, State, h, Element } from '@stencil/core';
/**
 * @slot app - Replaces app item, has replaceable props `{icon}`, `{name}`.
 */
@Component({
  tag: 'salla-apps-icons',
  styleUrl: 'salla-apps-icons.scss',
})
export class SallaAppsIcons {
  constructor() {
    this.appSlot = this.host.querySelector('[slot="app"]')?.innerHTML || `<img alt={name} src={icon} />`;
    salla.onReady(() => {
      this.apps = salla.config.get('store.apps');
    });

    salla.lang.onLoaded(() => {
      this.appsTitle = salla.lang.get('blocks.footer.download_apps');
    });
  }
  private readonly appSlot: string;
  @Element() host: HTMLElement;
  @State() apps = salla.config.get('store.apps');

  /**
   * Flag to show or hide title.
   */
  @Prop() hideTitle: boolean;

  /**
   * The title to display.
   */
  @Prop() appsTitle: string;

  /**
   * Display flag to horizontal/vertical.
   */
  @Prop() vertical: boolean;

  private getAppsArray() {
    return Object.entries(this.apps)
      .map(([name, value]) => ({ name, value }));
  }

  componentWillLoad() {
    return new Promise(resolve => salla.onReady(resolve));
  }

  render() {
    const appsArray = this.getAppsArray();
    if (Array.isArray(appsArray) && !appsArray.length) {
      return;
    }
    return (
      <Host class="s-apps-icons">
          {!this.hideTitle && <h3>{this.appsTitle}</h3>}
          <div class={{"s-apps-icons-list": true, "vertical": this.vertical}}>
            {appsArray.map((app, index) => (
               <a key={index} href={app.value as string} rel="noreferrer" target="_blank" class="s-apps-icons-item" id="app-slot" innerHTML={this.appSlot
                .replace(/\{icon\}/g, salla.url.cdn(`images/${app.name}.png`))
                .replace(/\{name\}/g, app.name)}>
              </a>
            ))}
          </div>
      </Host>
    );
  }
  componentDidRender() {
    this.host.querySelector('[slot="app"]')?.remove();
  }
}
